// expenseThunks.js ✅
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import APICaller from "../../utils/APICaller";
import { decrypt, encryptData } from "../../utils/Constants";
import { clearRedux } from "../slices/authSlice";

//Validate Token Thunk (Login + Email Verification)
export const validateTokenThunk = createAsyncThunk(
  "auth/validateToken",
  async (token, { rejectWithValue }) => {
    try {
      // 🖥️ Get device info
      let deviceInfo = {};
      try {
        const response = await axios.get(process.env.REACT_APP_IPIFY);
        if (response) {
          const userAgent = navigator.userAgent;
          const screenWidth = window.innerWidth;
          const screenHeight = window.innerHeight;
          const ip = response.data.ip;
          deviceInfo = { userAgent, screenWidth, screenHeight, ip };
        }
      } catch (err) {
        console.error("Error fetching IP:", err);
      }

      const endpoint = "/validateToken";
      const method = "POST";
      const payload = { auth: token, device: deviceInfo };

      const response = await APICaller(
        "",
        token,
        endpoint,
        method,
        payload,
        ""
      );

      if (response.statusCode !== 200) {
        return rejectWithValue(response);
      }

      const decryptedData = decrypt(
        response.respnse,
        process.env.REACT_APP_SSO_ENCRYPTION_KEY
      );
      const decryptedObject = JSON.parse(decryptedData);

      return {
        loginPayload: {
          lIU: decryptedObject?.user?.name,
          accessToken: decryptedObject?.accessToken,
          accessTokenExpiresOn: decryptedObject?.expiryTime,
        },
        emailVerificationPayload: {
          isLoggedIn: true,
          lIUId: decryptedObject?.user?._id,
          role: decryptedObject?.user?.roleID?.name,
          name: decryptedObject?.user?.name,
          empID: decryptedObject?.user?.empID,
          profileImage: decryptedObject?.user?.profilePicUrl,
          userInfo: encryptData({
            user: decryptedObject?.user,
            userDepartment: decryptedObject?.departmentNames,
            userDepartmentCode: decryptedObject?.departmentCode,
          }),
          logoutSuccessUrl: decryptedObject?.decryptedData?.logoutSuccessUrl,
        },
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

//ER Count Thunk
export const ercountThunk = createAsyncThunk(
  "auth/ercount",
  async ({ role, lIUId, token, accessTokenExpiresOn }, { rejectWithValue }) => {
    try {
      const endpoint = "/expenseRequestsCount";
      const method = "POST";
      const payload = { role, lIUId };

      const response = await APICaller(
        role,
        token,
        endpoint,
        method,
        payload,
        accessTokenExpiresOn
      );
      return response?.count;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

//Notification Count Thunk
export const ncountThunk = createAsyncThunk(
  "auth/ncount",
  async ({ role, lIUId, token, accessTokenExpiresOn }, { rejectWithValue }) => {
    try {
      const endpoint = "/notificationCount";
      const method = "POST";
      const payload = { role, lIUId };

      const response = await APICaller(
        role,
        token,
        endpoint,
        method,
        payload,
        accessTokenExpiresOn
      );
      return response?.count;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

//Signout Thunk
export const signoutThunk = createAsyncThunk(
  "auth/signOut",
  async (
    { role, lIUId, token, accessTokenExpiresOn },
    { rejectWithValue, dispatch }
  ) => {
    try {
      const endpoint = "/fetchWithoutPagination";
      const method = "POST";
      const payload = {
        route: "users",
        action: "upLoggedIn",
        lIUId: lIUId, // ✅ use the parameter
      };

      const response = await APICaller(
        role,
        token,
        endpoint,
        method,
        payload,
        accessTokenExpiresOn
      );

      if (response === true) {
        // Dispatch your existing clearRedux action
        dispatch(clearRedux(lIUId));

        // Redirect after clearing Redux
        window.location.href = process.env.REACT_APP_SSO_LOGIN_REDIRECT_URI;

        return true;
      } else {
        return rejectWithValue("Sign out failed");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);
